<div class="one-column-page">
  <div *ngIf="unitsLoaded" class="one-column-content">
    <app-feedstock-input (pageDirty)="changesMade($event)"></app-feedstock-input>
    <app-process-input (pageDirty)="changesMade($event)"></app-process-input>
    <app-financial-input (pageDirty)="changesMade($event)"></app-financial-input>
  </div>
</div>
